<template>
  <div class="grid-x grid-margin-x">
    <div class="cell medium-5 large-2">
      <div class="form-group is-required">
        <form-group
          :id="'items[' + rowIndex + '].productSKU'"
          v-model="rowData.productSKU"
          v-validate="'required'"
          type="text"
          :label="bp('consumerReturnsProductSKU')"
          :error="errors.first('items[' + rowIndex + '].productSKU')"
          :name="'items[' + rowIndex + '].productSKU'"
          :maxlength="100"
          :show-error-messages="false"
          :qaid="'row-' + rowIndex + '-productSKU'"
        ></form-group>
      </div>
    </div>
    <div class="cell medium-7 large-4">
      <div class="form-group is-required">
        <form-group
          :id="'items[' + rowIndex + '].productDescription'"
          v-model="rowData.productDescription"
          v-validate="'required'"
          type="text"
          :label="bp('consumerReturnsProductDescription')"
          :error="errors.first('items[' + rowIndex + '].productDescription')"
          :name="'items[' + rowIndex + '].productDescription'"
          :maxlength="500"
          :show-error-messages="false"
          :qaid="'row-' + rowIndex + '-productDescription'"
        ></form-group>
      </div>
    </div>
    <div class="cell medium-2 large-1">
      <div class="form-group is-required">
        <form-group
          :id="'items[' + rowIndex + '].qty'"
          v-model="rowData.qty"
          v-validate="'required'"
          type="number"
          :label="bp('qty')"
          :error="errors.first('items[' + rowIndex + '].qty')"
          :name="'items[' + rowIndex + '].qty'"
          :show-error-messages="false"
          :qaid="'row-' + rowIndex + '-qty'"
        ></form-group>
      </div>
    </div>
    <div class="cell medium-auto">
      <div class="form-group">
        <label for="select" class="form-label">{{ bp('returnReason') }}</label>
        <div class="select">
          <select
            :id="'items[' + rowIndex + '].returnReason'"
            :name="'items[' + rowIndex + '].returnReason'"
            required="required"
            class="form-control"
            :qaid="'row-' + rowIndex + '-reason'"
          >
            <option :value="bp('tooSmall')">{{ bp('tooSmall') }}</option>
            <option :value="bp('tooLarge')">{{ bp('tooLarge') }}</option>
            <option :value="bp('notAsDescribed')">{{ bp('notAsDescribed') }}</option>
            <option :value="bp('changedMind')">{{ bp('changedMind') }}</option>
            <option :value="bp('defective')">{{ bp('defective') }}</option>
            <option :value="bp('bontragerGuarantee')">{{ bp('bontragerGuarantee') }}</option>
            <option :value="bp('damaged')">{{ bp('damaged') }}</option>
            <option :value="bp('late')">{{ bp('late') }}</option>
            <option :value="bp('wrongItem')">{{ bp('wrongItem') }}</option>
            <option :value="bp('priceMatch')">{{ bp('priceMatch') }}</option>
            <option :value="bp('otherReason')">{{ bp('otherReason') }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="cell large-1 align-self-bottom">
      <div v-if="rowIndex !== 0" class="form-group md:form-group--inline mb-3">
        <trek-button
          tertiary
          icon-only
          form-inline
          :aria-label="bp('removeRow')"
          icon="delete"
          @click="$emit('deleteRow', rowIndex)"
        >
        </trek-button>
      </div>
    </div>
  </div>
</template>
<script>
import TrekButton from '@/components/TrekButton';
import FormGroup from '@/components/FormGroup';
export default {
  components: {
    TrekButton,
    FormGroup,
  },
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    validateFields: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({
        productSKU: '',
        productDescription: '',
        qty: '',
        returnReason: '',
      }),
    },
  },
  watch: {
    validateFields(value) {
      if (value) {
        this.$validator.validateAll().then((result) => {
          this.$emit('validationResult', result);
        });
      }
    },
  },
};
</script>
